export const AppUIParams = {
  primaryColor: '#3D5790',
  secundaryColor: '#B6385F',
  toolbarBackground: '#FFFFFF',
  appBackground: '#FFFFFF',
  actionButtonBlueColor: '#4A9CF2',
  actionButtonGreenColor: '#2DD172',
  actionButtonGreenColorOpacity: '#C0F1D5',
  actionButtonRedColor: '#D75C4D',
  actionButtonRedColorOpacity: '#F3CECA',
  actionButtonWhiteColor: '#FFFFFF',
  actionButtonBlackColor: '#000000',
  actionButtonOrangeBackgroundColor: '#EB936D',
  actionButtonOrangeBackgroundColorOpacity: '#F9DFD3',
  actionButtonGrayColor: '#BCC2DA',
  actionButtonGrayColorOpacity: '#EBEDF4',
  mapStrokeColor: '#489EBE',
  mapFillColor: '#489EBE',
  mapIconColor: '#EB936D',
  disabledTextColor: '#BCC2DA',
  iconColor: '#BCC2DA',

};
